import { Input, Modal } from 'antd'
import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const Wrapper = styled.div`
  line-height: 100%;
  padding: 15px 25px;
  background: #fafafb;
`
export const SubWrapper = styled.div`
  margin-bottom: 50px;
`
export const HeaderFlex = styled(Flex)`
  gap: ${props => (props?.gap ? '20px' : '10px')};
  margin: ${props => (props?.gap ? '10px' : '')};
`
export const UserName = styled.h2`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_XL};
  line-height: 28px;
  color: ${COLORS.GREY_P_100};
`
export const SubHeading = styled.p`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: #000000;
  margin-bottom: 30px;
`

export const CardRow = styled(Flex)`
  gap: 25px;
  margin: ${props => (props?.margin ? '10px 0' : '20px 0')};
`
export const CardRow1 = styled(Flex)`
  gap: 25px;
  margin: 20px;
`
export const SearchInput = styled(Input)`
  ::placeholder {
    font-size: 16px;
  }
  width: ${props => (props.width ? props.width : '250px')} !important;
  height: ${props => (props.height ? props.height : '40px')};
  border-radius: 8px;
  box-shadow: none;
  border-color: ${props => (props.error ? 'red' : '#e9e9e9')};
  :focus {
    border-color: #e9e9e9;
    box-shadow: none;
  }
  :hover {
    border-color: #e9e9e9;
  }
  :not(.ant-input-affix-wrapper-disabled):hover {
    border-color: #e9e9e9 !important;
  }
  .ant-input-affix-wrapper-focused {
    box-shadow: none;
    border-right-width: 0px !important;
  }
`
export const DivSearchInput = styled.div`
  border-right: 1px solid #e8e8e8;
  width: 80%;
`

export const ScrollContainer = styled.div`
  width: 680px;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  @media (max-width: 768px) {
    max-height: 200px;
  }
`

export const CarouselWrapper = styled.div`
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  scroll-behavior: smooth;
  ::-webkit-scrollbar {
    display: '';
  }
  &::-webkit-scrollbar {
    height: 0px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #cacaca;
    display: '';
  }
  &:hover {
    ::-webkit-scrollbar-thumb {
      display: block;
    }
  }
`

export const ArrowContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 30px;

  border-radius: 50%;
  color: #555;
  margin: 5px;
  font-size: 20px;
  transition: background-color 0.3s;
  &:hover {
  }
`
export const LeftArrow = styled(ArrowContainer)`
  position: sticky;
  left: 0;
  padding-top: 44px;
  margin-top: ${props => (props.time ? '27px' : '30px')};
  margin-left: -18px;
  align-items: end;
  padding-right: 0px;
  transform: translateY(-50%);
  z-index: 999;
`

export const RightArrow = styled(ArrowContainer)`
  position: sticky;
  right: 0;
  align-items: end;
  padding-top: 44px;
  margin-top: ${props => (props.time ? '27px' : '30px')};
  margin-left: -20px;
  transform: translateY(-50%);
  z-index: 999;
`

export const TextTitle = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-weight: 500;
  line-height: 15px;
  padding-left: 20px;
  color: #808697;
`

export const PopUpModel = styled(Modal)`
  width: 600px;
  height: 340px;
  padding: 40px;
`

export const FullPopupDiv = styled.div`
  align-items: center;
  justify-content: center;
  text-align: center;
`

export const Statustext = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  color: #999fac;
`

export const StyledEditBox = styled.div`
  width: 42px;
  height: 29px;
  background: #ffffff;
  color: #3249d7;
  border-radius: 5px;
  border: 1px solid #3249d7;
  display: flex;
  justify-content: center;
  align-items: center;
`
export const DriveModeText = styled.div`
  margin-left: 15px;
  font-family: Plus Jakarta Sans;
  font-size: 12px;
  font-weight: 500;
  color: #808697;
  span {
    font-family: Plus Jakarta Sans;
    font-size: 12px;
    font-weight: 800;
    color: #3249d7;
  }
`
export const StyledEditBox1 = styled.div`
  width: 42px;
  height: 29px;
  background: #ffffff;
  color: #909090;
  border-radius: 5px;
  border: 1px solid #d6d6d6;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const NoteMessageDivNew = styled(Flex)`
  line-height: 1rem;
  height: 40px;
  border: #d6dbf7 solid 2px;
  background-color: ${props => (props.mandatory ? '#3249d7' : 'white')};
  border-radius: 15px;
  justify-content: left;
  margin-bottom: 20px;
  transition: background-color 0.3s;
  color: ${props => (props.mandatory ? 'white' : '#3249d7')};
  display: inline-flex;
`
export const StyledSpaceDiv = styled.div`
  display: flex;
  gap: 4px;
  margin-left: 4px;
  align-items: center;
`

export const AlertTextDivNew = styled.div`
  font-size: 0.8em;
  color: ${props => (props.mandatory ? 'white' : '#3249d7')};
  margin-left: 4px;
  margin-right: 4px;
  font-weight: 600;
  margin-left: 4px;
  display: flex;
`
